<template>
    <dashboard>
        <row>
            <panel size="col-5" class="filters">
                <h3 slot="title">Filters</h3>
                <div class="filter-item">
                    <h4>Event</h4>
                    <app-tag v-if="eventTitle" closable @close="removeEvent">{{ eventTitle }}</app-tag>
                    <app-button v-else @click="showPicker = true">Pick Event</app-button>
                </div>
                <event-picker
                    v-model="showPicker"
                    state="all"
                    @selected-event="setEvent">
                    <template slot="title">Select Event</template>
                </event-picker>
            </panel>
            <panel size="col-19">
                <h2 slot="title">
                    Event Report
                    <span v-if="eventTitle">: {{ eventTitle }}</span>
                </h2>
                <template slot="buttons">
                    <app-button
                        size="small"
                        icon="icon-download"
                        class="no-text"
                        @click="handleDownload">
                        <span class="visuallyhidden">Download Report</span>
                    </app-button>
                </template>

                <el-table
                    :data="report"
                    :default-sort="{ prop: sort_by }"
                    style="width: 100%"
                    empty-text="None"
                    @current-change="navigateToStudentDetail"
                    @sort-change="sortChange">
                    <el-table-column
                        prop="student.first_name"
                        label="First Name"
                        sortable="custom"/>
                    <el-table-column prop="student.last_name" label="Last Name" sortable="custom"/>
                    <el-table-column prop="student.email" label="Email" sortable="custom"/>
                    <el-table-column 
                        prop="in_waitlist" 
                        label="Status" 
                        sortable="custom"
                        width="125px">
                        <template
                            slot-scope="scope">{{ scope.row.in_waitlist ? "Waitlisted" : "Attending" }}</template>
                    </el-table-column>
                </el-table>

                <pagination
                    :current-page="page"
                    :page-size="per_page"
                    :total="total"
                    layout="prev, pager, next, total"
                    @current-change="pageChange"/>
            </panel>
        </row>
    </dashboard>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import table from '@/mixins/table'
import download from '@/mixins/download'

import EventPicker from '../Event/EventPicker'

export default {
    name: 'page-reports-event',
    components: {
        EventPicker
    },
    mixins: [download, table],
    props: {
        uuid: String,
        per_page: {
            type: Number,
            default: 100
        }
    },
    data() {
        return {
            eventTitle: '',
            showPicker: false,
            tableParamKeys: ['uuid']
        }
    },
    computed: {
        ...mapState({
            report: ({ reportList }) => reportList.items,
            total: ({ reportList }) => reportList.total,
            authToken: ({ me }) => me.token
        })
    },
    mounted() {
        this.getEventReport(this.getParameters())
        if (this.uuid) {
            this.getEventDetail({ uuid: this.uuid }).then(({ title }) => {
                this.eventTitle = title
            })
        }
    },
    methods: {
        ...mapActions(['getEventReport', 'getEventDetail']),
        handleDownload() {
            let parameters = this.getParameters()
            this.postParameters('/api/v2/download/report/event',
                parameters,
                this.authToken)
        },
        paramsChanged(params) {
            this.getEventReport(params)
        },
        navigateToStudentDetail({ student }) {
            this.$router.push({
                name: 'students.detail',
                params: { uuid: student.uuid }
            })
        },
        setEvent({ uuid, title }) {
            let params = this.getParameters()
            params.uuid = uuid
            this.setParameters(params)
            this.eventTitle = title
        },
        removeEvent() {
            this.setEvent({ id: null, uuid: null, title: null })
        }
    }
}
</script>

<style lang="stylus"></style>
